import React from "react";
import { Link } from "react-router-dom";
import { LEGAL } from "../lib/legal";

export default function LegalFooter() {
  return (
    <footer className="border-t border-border px-6 py-3 text-xs text-neutral-500 flex flex-wrap items-center justify-between gap-3" data-testid="legal-footer">
      <div>
        © {new Date().getFullYear()} {LEGAL.companyName}. Educational platform — not investment advice.
      </div>
      <nav className="flex gap-3" data-testid="legal-footer-nav">
        <Link to="/legal/terms" className="hover:text-white" data-testid="footer-link-terms">Terms</Link>
        <Link to="/legal/privacy" className="hover:text-white" data-testid="footer-link-privacy">Privacy</Link>
        <Link to="/legal/risk" className="hover:text-white" data-testid="footer-link-risk">Risk Disclosure</Link>
        <Link to="/legal/disclaimer" className="hover:text-white" data-testid="footer-link-disclaimer">Disclaimer</Link>
        <Link to="/legal/cookies" className="hover:text-white" data-testid="footer-link-cookies">Cookies</Link>
      </nav>
    </footer>
  );
}
